import { getHideAnnouncement, processMutltiAnnouncementMarkStatus, deviceDetector } from '@pm/super-library-2/modules/announcement';
import { getCurrentLanguageCountryKey } from '@pm/super-library-2/utils';

import { gu_getNestedValue } from './general-util';

// NOTE: This file for announcement function only
// All function name start from announcement_ (announcement util) to indicate the function come from here
export function announcement_generateDelaySpeed(linearTime, vm) {
    const { screen } = vm.props;
    return (screen && screen.viewType !== 'mobile') || linearTime <= 15
        ? 0
        : linearTime / (linearTime > 40 ? -2.48 : linearTime > 36 ? -2.65 : linearTime > 31 ? -2.8 : linearTime > 25 ? -3.3 : linearTime > 20 ? -4 : linearTime > 15 && -8);
}

export function announcement_massageStyleAndProceedAnimation(vm, isMoveVertical) {
    const { settings } = vm.props.portal;

    if (!gu_getNestedValue(settings, 'features.announcementConfig.disableAnnounceAnimation')) {
        const contentDiv = document.getElementById('msg-content');
        const textDiv = document.getElementById('msgAnimate');
        const viewType = vm.props.screen.viewType;

        if (textDiv && contentDiv) {
            if (isMoveVertical) {
                const customKeyframe = 'custom-noticeFade';

                const style = document.createElement('style');
                style.type = 'text/css';
                style.innerText = `
                  @keyframes ${customKeyframe} {
                    0% { opacity: 0; }
                    10% { opacity: 1; }
                    90% { opacity: 1; }
                    100% { opacity: 0; }
                  }
                `;
                document.head.appendChild(style);

                setTimeout(() => {
                    vm.setState({
                        isAnimating: true,
                        customKeyframe,
                        announcementSpeed: 5,
                        specialTranslate: 'translateY(0)',
                        customTextColor: null,
                    });
                }, 0);
            } else {
                requestAnimationFrame(() => {
                    const contentWidth = contentDiv.offsetWidth;
                    const textWidth = textDiv.offsetWidth;

                    const distance = contentWidth + textWidth;
                    const speed = 100;
                    const duration = distance / speed;

                    const customKeyframe = 'custom-noticeFade';
                    const keyframes = `
                      @keyframes ${customKeyframe} {
                        from { transform: translateX(${contentWidth}px); }
                        to { transform: translateX(-${textWidth}px); }
                      }
                    `;

                    const style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerText = keyframes;
                    document.head.appendChild(style);

                    const applyState = (customTextColor) => {
                        vm.setState({
                            isAnimating: true,
                            announcementSpeed: duration,
                            specialTranslate: `translateX(${contentWidth}px)`,
                            customKeyframe,
                            customTextColor,
                        });
                    };

                    if (settings && settings.features && settings.features.getAnnoucementStyle) {
                        window.SPL_Content.getAnnoucementStyle().then((announcementStyle) => {
                            let customTextColor = null;
                            if (announcementStyle) {
                                if (viewType === 'web' && announcementStyle.color) {
                                    customTextColor = announcementStyle.color;
                                } else if (viewType === 'mobile' && announcementStyle.mColor) {
                                    customTextColor = announcementStyle.mColor;
                                }
                            }
                            setTimeout(() => applyState(customTextColor), 0);
                        });
                    } else {
                        setTimeout(() => applyState(null), 0);
                    }
                });
            }
        }
    }
}
export function getMaintenanceAnnouncementList(vm) {
    const { language } = vm.props;

    window.SPL_Provider.getWeeklyProviderMaintenance({}, function (data) {
        if (data) {
            let filteredData = [];
            for (let i = 0, l = data.length; i < l; i++) {
                const currentData = data[i];
                if (currentData.currency === language.currencyLang) {
                    filteredData.push(currentData);
                }
            }

            vm.setState({ maintenanceAnnouncementList: filteredData });
        }
    });
}
export function announcement_checkAnnouncementRelease(announcementList) {
    const { countryLanguageKey } = getCurrentLanguageCountryKey();
    const announcement = `${announcementList?.id}_${countryLanguageKey}`;
    const { announcementHideList } = getHideAnnouncement();
    const storedData = localStorage.getItem('dailyAppearFrequency');
    const getCurrentHideAnnouncementList = storedData ? JSON.parse(storedData) : {};
    const currentHideAnnouncement = getCurrentHideAnnouncementList[announcement] || null;
    if (!currentHideAnnouncement && !announcementHideList) return true;
    const availableContent = announcementList?.content ?? null;
    const todayDate = new Date().getDate().toString();

    const checkValidArray = (array, isBoolean) => {
        return array && Array.isArray(array) && array.length > 0 ? (isBoolean ? Boolean(array) : array) : false;
    };

    const announcementTypeChanged = currentHideAnnouncement && currentHideAnnouncement?.announcementType !== availableContent?.frequencyType;
    const announcementFreqChanged =
        currentHideAnnouncement && currentHideAnnouncement?.oriCount !== availableContent?.dailyAppearFrequency && getCurrentHideAnnouncementList[announcement];
    const announcementOnceChanged = announcementHideList ? availableContent.frequencyType !== 'once' && announcementHideList.includes(`${announcement}_once`) : false;
    const removePassRecord = currentHideAnnouncement && todayDate !== currentHideAnnouncement?.todayDate;

    if (announcementTypeChanged || removePassRecord) {
        delete getCurrentHideAnnouncementList[announcement];
    } else if (announcementFreqChanged) {
        getCurrentHideAnnouncementList[announcement].currentCount = 0;
        getCurrentHideAnnouncementList[announcement].oriCount = availableContent.dailyAppearFrequency;
    }

    const updatedRemoveAnnouncement = (checkValidArray(announcementHideList) || []).filter((item) =>
        announcementOnceChanged ? item !== `${announcement}_once` : announcementTypeChanged || announcementFreqChanged || removePassRecord ? item !== announcement : item
    );

    if (!announcementOnceChanged) localStorage.setItem('dailyAppearFrequency', JSON.stringify(getCurrentHideAnnouncementList));
    if (announcementOnceChanged || announcementTypeChanged || announcementFreqChanged || removePassRecord) localStorage.setItem('announcementId', updatedRemoveAnnouncement);

    return checkValidArray(updatedRemoveAnnouncement, true) ? updatedRemoveAnnouncement.every((item) => !item.includes(announcement)) : true;
}

export function announcement_filterAndSortingAnnouncement(annoucementList) {
    return Array.isArray(annoucementList) && annoucementList.length > 0
        ? [...annoucementList]
              .filter((a) => announcement_checkAnnouncementRelease(a))
              .sort((a, b) => {
                  return a.seq - b.seq || b.id - a.id;
              })
        : [];
}

export async function announcement_filterMultiAnnouncementMarkStatus(announcementList) {
    if (!Array.isArray(announcementList) || announcementList.length === 0) {
        return [];
    }

    const updatedList = await Promise.all(
        announcementList.map(async (element) => {
            const updatedMultiAnnouncements = await Promise.all(
                (element.multiAnnouncements || []).map(async (item) => {
                    const shouldMark = await processMutltiAnnouncementMarkStatus(item.id, announcementList, element.id);
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            mark: item.content?.mark && shouldMark ? false : item.content.mark,
                        },
                    };
                })
            );

            return {
                ...element,
                multiAnnouncements: updatedMultiAnnouncements,
            };
        })
    );
    return updatedList;
}

export const announcement_textAnnouncementConvertor = (textAnnouncement) => {
    const { currentPlatform } = deviceDetector();
    function stripHtmlTags(html) {
        return html.replace(/<[^>]+>/g, '');
    }

    let textAnnouncementList = [];
    Array.isArray(textAnnouncement) &&
        textAnnouncement.length > 0 &&
        textAnnouncement.forEach((announcement) => {
            textAnnouncementList.push(stripHtmlTags(announcement.content[currentPlatform].text));
        });
    return textAnnouncementList;
};
